export const misFilterData = [
    {
      id: 1,
      primaryText: 'Duty Type',
      isRadio: true, 
      subItems: [
        { value: 'rental', list: 'Rental', key: 'DutyType' },
        { value: 'airport', list: 'Airport', key: 'DutyType' },
        { value: 'outStation', list: 'OutStation', key: 'DutyType' },
      ],
    },
    {
      id: 2,
      primaryText: 'Bill Type',
      subItems: [
        { value: '2', list: 'Bill to company', key: 'Status' },
        { value: '1', list: 'Bill to Credit card', key: 'Status' },
      ],
    },
  ];

  export const misFilterOptions = ( subCompanyList, cityList) =>  [
    {
      id: 2,
      name: "city",
      placeholder: "All City",
      options: cityList
    },
    {
      id: 1,
      name: "companyName",
      placeholder: "All Company Name",
      options: subCompanyList
    },
    ];